module.exports = __webpack_public_path__ + "static/img/c_znzz76.ca42086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c_znzz76.png
// module id = VR+h
// module chunks = 73